var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDynamodb = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5294CF",
    fillRule: "evenodd",
    d: "M23.77 35h.357l5.835-2.978.098-.14V8.116l-.098-.141L24.127 5h-.362z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F5B98",
    fillRule: "evenodd",
    d: "M16.23 35h-.36l-5.81-2.978-.118-.207-.06-23.578.177-.262L15.87 5h.366l-.004 30",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D72B8",
    fillRule: "evenodd",
    d: "M15.823 5h8.295v30h-8.294V5Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A476F",
    fillRule: "evenodd",
    d: "m33 19.297-.196-.044-2.807-.268-.04.021-5.822-.238h-8.27l-5.821.238v-4.542l-.006.003.006-.013 5.82-1.38h8.271l5.82 1.38 2.14 1.164v-.748l.905-.102-.094-.187-2.863-2.095-.088.03-5.82-1.847h-8.27l-5.821 1.846V7.952L7 11.602v3.187l.023-.018.881.099v.763L7 16.129V19.3l.023-.003.881.014v1.33l-.76.013L7 20.639v3.173l.904.498v.772l-.867.098L7 25.151v3.187l3.044 3.65v-4.563l5.82 1.846h8.271l5.838-1.851.078.034 2.825-2.064.124-.206-.904-.102v-.757l-.118-.048-1.935 1.067-.07.15-5.838 1.372v.001h-8.27v-.001l-5.821-1.378v-4.56l5.82.238v.006h8.271l5.82-.244.133.063 2.72-.24.192-.096-.904-.013V19.31l.904-.014",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D72B8",
    d: "M29.942 27.425v4.563L33 28.338v-3.166l-3.04 2.248zm0-1.927.017-.005L33 23.827v-3.185l-3.058.286zm.017-11.04-.017-.004v4.552l3.058.291v-3.184l-3.04-1.655Zm0-1.925L33 14.768v-3.166l-3.058-3.65v4.563l.017.006z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDynamodb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dynamodb.f5812546.svg";